export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

// 产品数据格式化
export function formatGoods(data) {
  data.forEach((res) => {
    if (
      res.spec != undefined &&
      res.spec.length != 0 &&
      res.spec != null &&
      res.spec != ""
    ) {
      res.goods_price = res.spec[0]["goods_price"];
      res.goods_market_price = res.spec[0]["goods_market_price"];
      res.goods_num = res.spec[0]["goods_num"];
      res.all_goods_num = 0;
      res.spec.forEach((specRes) => {
        res.all_goods_num += parseInt(specRes.goods_num);
      });
    }
  });

  return data;
}

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 */
export function formatMoney(number) {
  let decimals = 2; //保留几位小数
  let decPoint = "."; //小数点符号 默认.
  let thousandsSep = ","; //千分位符号 默认为,

  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  let n = !isFinite(+number) ? 0 : +number;
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  let sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
  let dec = typeof decPoint === "undefined" ? "." : decPoint;
  let s = "";
  let toFixedFix = function(n, prec) {
    let k = Math.pow(10, prec);
    return "" + Math.ceil(n * k) / k;
  };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  let re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}
